import { useEffect, useState } from 'react';

import { SubscriptionNode } from '../../Common/ConsumerModels/SubcriptionNode';
import {
  addSubscriptionNodeFields,
  filterBySearchQuery,
} from '../../Common/Helper/subscriptionNodeHelper';

export function useViewSubscriptionAttributes(
  requestedApprovedAttributes: SubscriptionNode[],
  searchQuery: string
) {
  const [formattedSubscriptionNodes, setFormattedSubscriptionNodes] = useState<SubscriptionNode[]>([]);
  const [filteredSubscriptionNodes, setFilteredSubscriptionNodes] = useState<SubscriptionNode[]>([]);
  const [isAttributeSubscriptionLoading, setIsAttributeSubscriptionLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsAttributeSubscriptionLoading(true);
    const formattedNodeList: SubscriptionNode[] = addSubscriptionNodeFields(requestedApprovedAttributes);
    const newFormattedApprovedAttributes: SubscriptionNode[] = JSON.parse(
      JSON.stringify(formattedNodeList) // deep copy
    );
    const newFilteredApprovedAttributes: SubscriptionNode[] = JSON.parse(
      JSON.stringify(formattedNodeList) // deep copy
    );
    setFormattedSubscriptionNodes(newFormattedApprovedAttributes);
    setFilteredSubscriptionNodes(newFilteredApprovedAttributes);
    setIsAttributeSubscriptionLoading(false);
  }, [requestedApprovedAttributes]);

  useEffect(() => {
    setIsAttributeSubscriptionLoading(true);
    const approvedAttributesFilteredBySearchQuery: SubscriptionNode[] = filterBySearchQuery(
      formattedSubscriptionNodes,
      searchQuery
    );
    setFilteredSubscriptionNodes(approvedAttributesFilteredBySearchQuery);
    setIsAttributeSubscriptionLoading(false);
  }, [searchQuery, formattedSubscriptionNodes]);

  return [
    formattedSubscriptionNodes,
    setFormattedSubscriptionNodes,
    filteredSubscriptionNodes,
    setFilteredSubscriptionNodes,
    isAttributeSubscriptionLoading,
  ] as const;
}
